import { QueryParams } from "@/api";

export interface RosterClassroomFilter extends QueryParams {
  provider: string;
}

export interface School {
  id: string;
  name: string;
  unique_id: string;
}

export interface RosterClassroom {
  id: string;
  pk: string;
  unique_id: string | null;
  grade: number | null;
  is_synced: boolean;
  name: string;
  school: School | Record<string, never>;
  subject_slugs: string[];
}

export interface RosterClassroomResponse extends Array<RosterClassroom> {}

export const rosterClassroomFilterMock: RosterClassroomFilter = {
  provider: "google-oauth2",
};

export const rosterClassroomResponseMock: RosterClassroomResponse = [
  {
    id: "654618831248",
    pk: "654618831248",
    unique_id: null,
    name: "Class 3",
    grade: null,
    is_synced: false,
    subject_slugs: [],
    school: {
      id: "123",
      name: "School 1",
      unique_id: "123",
    },
  },
  {
    id: "654617192158",
    pk: "654617192158",
    unique_id: null,
    name: "Class 2",
    grade: null,
    is_synced: false,
    subject_slugs: [],
    school: {},
  },
  {
    id: "654619129003",
    pk: "654619129003",
    unique_id: null,
    name: "Class 1",
    grade: null,
    is_synced: false,
    subject_slugs: ["other"],
    school: {},
  },
  {
    id: "6546191290032",
    pk: "6546191290032",
    unique_id: null,
    name: "Class 12",
    grade: null,
    is_synced: true,
    subject_slugs: ["other"],
    school: {},
  },
  {
    id: "6546191290032",
    pk: "6546191290032",
    unique_id: "6546191290032",
    name: "Class 12",
    grade: 4,
    is_synced: true,
    subject_slugs: ["other"],
    school: {
      id: "123",
      name: "School 1",
      unique_id: "123",
    },
  },
  {
    id: "6546191290032",
    pk: "6546191290032",
    unique_id: "6546191290032",
    name: "Class 12",
    grade: 4,
    is_synced: false,
    subject_slugs: ["other"],
    school: {
      id: "123",
      name: "School 1",
      unique_id: "123",
    },
  },
];
